const init = instance => {
    let $players = document.querySelectorAll('[name^="vgtrk_player"]');

    instance.players = [ ...$players ].map($el => {
        let name      = $el.getAttribute('name');
        let frame     = window.frames[name];
        let isPlaying = !!$el.getAttribute('src').match('isPlay/true')

        return {
            $el,
            frame,
            isPlaying
        }
    });

    window.addEventListener('scroll', event => {
        watch(instance.players)
    });
    window.addEventListener('resize', event => {
        watch(instance.players)
    });
};

const watch = players => {

    players.forEach(player => {
        let bounding     = player.$el.getBoundingClientRect();
        let offsetTop    = bounding.top;
        let offsetBottom = bounding.bottom;
        let height       = (offsetBottom - offsetTop) / 100 * 55;

        let $sliderItem = player.$el.closest('.media__item');

        if ($sliderItem && !$sliderItem.classList.contains('media__item--active')) {
            return;
        }
        if (offsetTop <= (window.innerHeight - height) && offsetBottom >= height) {
            if (player.isPlaying) {
                let message = {
                    action: 'play',
                    adv:    false
                }
                player.frame.postMessage(JSON.stringify(message), '*');
                player.isPlaying = false;
            }
        } else {
            if (!player.isPlaying) {
                player.frame.postMessage('pause', '*');
                player.isPlaying = true;
            }
        }
    })
};

export default class PlayerStarter {
    constructor() {
        this.players = null;

        return init(this);
    }
}
